[
  {
    "name": "gen_ai.provider.name",
    "description": "The Generative AI provider as identified by the client or server instrumentation."
  },
  {
    "name": "gen_ai.request.model",
    "description": "The name of the GenAI model a request is being made to.",
    "exampleValue": "gpt-4"
  },
  {
    "name": "gen_ai.request.max_tokens",
    "description": "The maximum number of tokens the model generates for a request.",
    "exampleValue": "100"
  },
  {
    "name": "gen_ai.request.choice.count",
    "description": "The target number of candidate completions to return.",
    "exampleValue": "3"
  },
  {
    "name": "gen_ai.request.temperature",
    "description": "The temperature setting for the GenAI request.",
    "exampleValue": "0"
  },
  {
    "name": "gen_ai.request.top_p",
    "description": "The top_p sampling setting for the GenAI request.",
    "exampleValue": "1"
  },
  {
    "name": "gen_ai.request.top_k",
    "description": "The top-K sampling setting for the GenAI request: restricts token generation at each step to the K most likely next tokens.\n",
    "exampleValue": "40"
  },
  {
    "name": "gen_ai.request.stop_sequences",
    "description": "List of sequences that the model will use to stop generating further tokens.",
    "exampleValue": "[\"forest\",\"lived\"]"
  },
  {
    "name": "gen_ai.request.frequency_penalty",
    "description": "The frequency penalty setting for the GenAI request.",
    "exampleValue": "0.1"
  },
  {
    "name": "gen_ai.request.presence_penalty",
    "description": "The presence penalty setting for the GenAI request.",
    "exampleValue": "0.1"
  },
  {
    "name": "gen_ai.request.encoding_formats",
    "description": "The encoding formats requested in an embeddings operation, if specified.",
    "exampleValue": "[\"base64\"], [\"float\",\"binary\"]"
  },
  {
    "name": "gen_ai.request.seed",
    "description": "Requests with same seed value more likely to return same result.",
    "exampleValue": "100"
  },
  {
    "name": "gen_ai.request.stream",
    "description": "Indicates whether the GenAI request was made in streaming mode."
  },
  {
    "name": "gen_ai.request.reasoning.level",
    "description": "The reasoning or thinking effort level requested for a GenAI model.\n",
    "exampleValue": "low, medium, high"
  },
  {
    "name": "gen_ai.request.previous_response.id",
    "description": "The unique identifier of a previous response or interaction used to provide context for the current operation.",
    "exampleValue": "resp_0123456789aBCdef, interaction-123"
  },
  {
    "name": "gen_ai.request.stream_cursor",
    "description": "The cursor identifying the last streamed event already received, used to resume a streamed response from that position.",
    "exampleValue": "42, event-abc123"
  },
  {
    "name": "gen_ai.response.id",
    "description": "The unique identifier for the completion.",
    "exampleValue": "chatcmpl-123"
  },
  {
    "name": "gen_ai.response.model",
    "description": "The name of the model that generated the response.",
    "exampleValue": "gpt-4-0613"
  },
  {
    "name": "gen_ai.response.finish_reasons",
    "description": "Array of reasons the model stopped generating tokens, corresponding to each generation received.",
    "exampleValue": "[\"stop\"], [\"stop\",\"length\"], [\"stop\",\"length\",\"error\"]"
  },
  {
    "name": "gen_ai.response.status",
    "description": "The lifecycle status of a generated response, as reported by the provider when the response is fetched or polled.",
    "exampleValue": "completed, in_progress"
  },
  {
    "name": "gen_ai.response.time_to_first_chunk",
    "description": "Time to first chunk in a streaming response, measured from request issuance, in seconds. The value is measured from when the client issues the generation request to when the first chunk is received in the response stream.\n",
    "exampleValue": "0.5, 1.2"
  },
  {
    "name": "gen_ai.usage.input_tokens",
    "description": "The number of tokens used in the GenAI input (prompt).",
    "exampleValue": "100"
  },
  {
    "name": "gen_ai.usage.cache_read.input_tokens",
    "description": "The number of input tokens served from a provider-managed cache.",
    "exampleValue": "50"
  },
  {
    "name": "gen_ai.usage.cache_write.input_tokens",
    "description": "The number of input tokens written to a provider-managed cache.",
    "exampleValue": "25"
  },
  {
    "name": "gen_ai.usage.text.input_tokens",
    "description": "The number of text input tokens.",
    "exampleValue": "100"
  },
  {
    "name": "gen_ai.usage.image.input_tokens",
    "description": "The number of image input tokens.",
    "exampleValue": "258"
  },
  {
    "name": "gen_ai.usage.audio.input_tokens",
    "description": "The number of audio input tokens.",
    "exampleValue": "120"
  },
  {
    "name": "gen_ai.usage.output_tokens",
    "description": "The number of tokens used in the GenAI response (completion).",
    "exampleValue": "180"
  },
  {
    "name": "gen_ai.usage.reasoning.output_tokens",
    "description": "The number of output tokens used for reasoning (e.g. chain-of-thought, extended thinking).",
    "exampleValue": "50"
  },
  {
    "name": "gen_ai.usage.text.output_tokens",
    "description": "The number of text output tokens.",
    "exampleValue": "180"
  },
  {
    "name": "gen_ai.usage.image.output_tokens",
    "description": "The number of image output tokens.",
    "exampleValue": "1290"
  },
  {
    "name": "gen_ai.usage.audio.output_tokens",
    "description": "The number of audio output tokens.",
    "exampleValue": "240"
  },
  {
    "name": "gen_ai.usage.text.cache_read.input_tokens",
    "description": "The number of text input tokens served from a provider-managed cache.",
    "exampleValue": "40"
  },
  {
    "name": "gen_ai.usage.image.cache_read.input_tokens",
    "description": "The number of image input tokens served from a provider-managed cache.",
    "exampleValue": "128"
  },
  {
    "name": "gen_ai.usage.audio.cache_read.input_tokens",
    "description": "The number of audio input tokens served from a provider-managed cache.",
    "exampleValue": "60"
  },
  {
    "name": "gen_ai.token.modality",
    "description": "The modality of the tokens being counted.",
    "exampleValue": "text, image, audio"
  },
  {
    "name": "gen_ai.conversation.id",
    "description": "The unique identifier for a conversation (session, thread), used to store and correlate messages within this conversation.",
    "exampleValue": "conv_5j66UpCpwteGg4YSxUnt7lPY"
  },
  {
    "name": "gen_ai.conversation.compacted",
    "description": "Indicates whether the effective conversation context used for this operation is a compacted view of a prior conversation.",
    "exampleValue": "true"
  },
  {
    "name": "gen_ai.agent.id",
    "description": "The unique and stable identifier of the GenAI hosted agent resource.",
    "exampleValue": "asst_5j66UpCpwteGg4YSxUnt7lPY, arn:aws:bedrock:us-east-1:123:agent/42, urn:agent:projects-123:projects:123:locations:us-east1:aiplatform:reasoningEngines:456"
  },
  {
    "name": "gen_ai.agent.name",
    "description": "Human-readable name of the GenAI agent provided by the application.",
    "exampleValue": "Math Tutor, Fiction Writer"
  },
  {
    "name": "gen_ai.agent.description",
    "description": "Free-form description of the GenAI agent provided by the application.",
    "exampleValue": "Helps with math problems, Generates fiction stories"
  },
  {
    "name": "gen_ai.agent.version",
    "description": "The version of the GenAI agent.",
    "exampleValue": "1.0.0, 2025-05-01"
  },
  {
    "name": "gen_ai.main_agent.id",
    "description": "The unique and stable identifier of the top-level Generative AI agent in the process",
    "exampleValue": "asst_5j66UpCpwteGg4YSxUnt7lPY, arn:aws:bedrock:us-east-1:123:agent/42, urn:agent:projects-123:projects:123:locations:us-east1:aiplatform:reasoningEngines:456"
  },
  {
    "name": "gen_ai.main_agent.name",
    "description": "The human-readable name of the top-level Generative AI agent in the process.",
    "exampleValue": "Math Tutor, Fiction Writer"
  },
  {
    "name": "gen_ai.main_agent.description",
    "description": "The free-form description of the top-level Generative AI agent in the process.",
    "exampleValue": "Helps with math problems, Generates fiction stories"
  },
  {
    "name": "gen_ai.tool.name",
    "description": "Name of the tool utilized by the agent.",
    "exampleValue": "Flights"
  },
  {
    "name": "gen_ai.tool.call.id",
    "description": "The tool call identifier.",
    "exampleValue": "call_mszuSIzqtI65i1wAUOE8w5H4"
  },
  {
    "name": "gen_ai.tool.description",
    "description": "The tool description.",
    "exampleValue": "Multiply two numbers"
  },
  {
    "name": "gen_ai.tool.type",
    "description": "Type of the tool utilized by the agent",
    "exampleValue": "function, extension, datastore"
  },
  {
    "name": "gen_ai.tool.call.arguments",
    "description": "Parameters passed to the tool call.",
    "exampleValue": "{\n    \"location\": \"San Francisco?\",\n    \"date\": \"2025-10-01\"\n}\n"
  },
  {
    "name": "gen_ai.tool.call.result",
    "description": "The result returned by the tool call (if any and if execution was successful).",
    "exampleValue": "{\n  \"temperature_range\": {\n    \"high\": 75,\n    \"low\": 60\n  },\n  \"conditions\": \"sunny\"\n}\n"
  },
  {
    "name": "gen_ai.tool.definitions",
    "description": "The list of tool definitions available to the GenAI agent or model.",
    "exampleValue": "[\n  {\n    \"type\": \"function\",\n    \"name\": \"get_current_weather\",\n    \"description\": \"Get the current weather in a given location\",\n    \"parameters\": {\n      \"type\": \"object\",\n      \"properties\": {\n        \"location\": {\n          \"type\": \"string\",\n          \"description\": \"The city and state, e.g. San Francisco, CA\"\n        },\n        \"unit\": {\n          \"type\": \"string\",\n          \"enum\": [\n            \"celsius\",\n            \"fahrenheit\"\n          ]\n        }\n      },\n      \"required\": [\n        \"location\",\n        \"unit\"\n      ]\n    }\n  }\n]\n"
  },
  {
    "name": "gen_ai.data_source.id",
    "description": "The data source identifier.",
    "exampleValue": "H7STPQYOND"
  },
  {
    "name": "gen_ai.operation.name",
    "description": "The name of the operation being performed."
  },
  {
    "name": "gen_ai.output.type",
    "description": "Represents the content type requested by the client."
  },
  {
    "name": "gen_ai.embeddings.dimension.count",
    "description": "The number of dimensions the resulting output embeddings should have.",
    "exampleValue": "512, 1024"
  },
  {
    "name": "gen_ai.retrieval.documents",
    "description": "The documents retrieved.",
    "exampleValue": "[\n  {\n    \"id\": \"doc_123\",\n    \"score\": 0.95\n  },\n  {\n    \"id\": \"doc_456\",\n    \"score\": 0.87\n  },\n  {\n    \"id\": \"doc_789\",\n    \"score\": 0.82\n  }\n]\n"
  },
  {
    "name": "gen_ai.retrieval.query.text",
    "description": "The query text used for retrieval.",
    "exampleValue": "What is the capital of France?, weather in Paris"
  },
  {
    "name": "gen_ai.retrieval.top_k",
    "description": "The maximum number of documents the retriever was asked to return for the query (also known as `k`, `limit`, or `max_num_results`).\n",
    "exampleValue": "5"
  },
  {
    "name": "gen_ai.memory.store.id",
    "description": "The unique identifier of the memory store.",
    "exampleValue": "ms_abc123, user-preferences-store"
  },
  {
    "name": "gen_ai.memory.record.id",
    "description": "The unique identifier of the memory record.",
    "exampleValue": "mem_5j66UpCpwteGg4YSxUnt7lPY"
  },
  {
    "name": "gen_ai.memory.record.count",
    "description": "The number of memory records relevant to the operation.",
    "exampleValue": "3"
  },
  {
    "name": "gen_ai.memory.query.text",
    "description": "The search query used to retrieve memories.",
    "exampleValue": "user dietary preferences, past flight bookings"
  },
  {
    "name": "gen_ai.memory.records",
    "description": "The memory records stored or retrieved in a memory operation.",
    "exampleValue": "[\n  {\n    \"content\": \"User prefers dark mode\",\n    \"id\": \"mem_123\",\n    \"score\": 0.95\n  },\n  {\n    \"content\": {\n      \"preference\": \"vegetarian meals\",\n      \"confidence\": 0.9\n    },\n    \"metadata\": {\n      \"source\": \"profile\"\n    }\n  }\n]\n"
  },
  {
    "name": "gen_ai.system_instructions",
    "description": "The system message or instructions provided to the GenAI model separately from the chat history.",
    "exampleValue": "[\n  {\n    \"type\": \"text\",\n    \"content\": \"You are an Agent that greet users, always use greetings tool to respond\"\n  }\n]\n, [\n  {\n    \"type\": \"text\",\n    \"content\": \"You are a language translator.\"\n  },\n  {\n    \"type\": \"text\",\n    \"content\": \"Your mission is to translate text in English to French.\"\n  }\n]\n"
  },
  {
    "name": "gen_ai.input.messages",
    "description": "The chat history provided to the model as an input.\n",
    "exampleValue": "[\n  {\n    \"role\": \"user\",\n    \"parts\": [\n      {\n        \"type\": \"text\",\n        \"content\": \"Weather in Paris?\"\n      }\n    ]\n  },\n  {\n    \"role\": \"assistant\",\n    \"parts\": [\n      {\n        \"type\": \"tool_call\",\n        \"id\": \"call_VSPygqKTWdrhaFErNvMV18Yl\",\n        \"name\": \"get_weather\",\n        \"arguments\": {\n          \"location\": \"Paris\"\n        }\n      }\n    ]\n  },\n  {\n    \"role\": \"tool\",\n    \"parts\": [\n      {\n        \"type\": \"tool_call_response\",\n        \"id\": \"call_VSPygqKTWdrhaFErNvMV18Yl\",\n        \"response\": \"rainy, 57°F\"\n      }\n    ]\n  }\n]\n"
  },
  {
    "name": "gen_ai.output.messages",
    "description": "Messages returned by the model where each message represents a specific model response (choice, candidate).",
    "exampleValue": "[\n  {\n    \"role\": \"assistant\",\n    \"parts\": [\n      {\n        \"type\": \"text\",\n        \"content\": \"The weather in Paris is currently rainy with a temperature of 57°F.\"\n      }\n    ]\n  }\n]\n"
  },
  {
    "name": "gen_ai.evaluation.name",
    "description": "The name of the evaluation metric used for the GenAI response.",
    "exampleValue": "Relevance, IntentResolution"
  },
  {
    "name": "gen_ai.evaluation.score.value",
    "description": "The evaluation score returned by the evaluator.",
    "exampleValue": "4"
  },
  {
    "name": "gen_ai.evaluation.score.label",
    "description": "Human readable label for evaluation.",
    "exampleValue": "relevant, not_relevant, correct, incorrect, pass, fail"
  },
  {
    "name": "gen_ai.evaluation.explanation",
    "description": "A free-form explanation for the assigned score provided by the evaluator.",
    "exampleValue": "The response is factually accurate but lacks sufficient detail to fully address the question."
  },
  {
    "name": "gen_ai.prompt.name",
    "description": "The name of the prompt that uniquely identifies it.",
    "exampleValue": "analyze-code"
  },
  {
    "name": "gen_ai.prompt.version",
    "description": "The version of the prompt template used.",
    "exampleValue": "1.0.0, 2025-05-01, prod, v2"
  },
  {
    "name": "gen_ai.prompt.variable",
    "description": "The variables supplied to the prompt template, the `<key>` being the variable name, the value being the variable value.",
    "exampleValue": "Alice, French"
  },
  {
    "name": "gen_ai.workflow.name",
    "description": "Human-readable name of the GenAI workflow provided by the application.",
    "exampleValue": "multi_agent_rag, customer_support_pipeline"
  },
  {
    "name": "gen_ai.skill.name",
    "description": "The name of the [Agent Skill](https://agentskills.io/specification#skill-md-format).",
    "exampleValue": "code-review, pdf-processing"
  },
  {
    "name": "gen_ai.skill.description",
    "description": "The [description of the Agent Skill](https://agentskills.io/specification#skill-md-format).",
    "exampleValue": "Review a changelist against the team's review policy."
  },
  {
    "name": "gen_ai.skill.source.uri",
    "description": "The source URI for loading the skill.",
    "exampleValue": "https://skills.example.com/code-review, gs://example-skills/code-review, file:///opt/skills/code-review"
  },
  {
    "name": "gen_ai.skill.resource.name",
    "description": "The skill-relative name of the resource (script, reference, or asset) being accessed or executed.",
    "exampleValue": "references/review_policy.md, assets/report_template.html"
  }
]
